import React, {useEffect} from 'react';
import classNames from 'classnames';
import {useAnimationsContext} from '../../../contexts';
import styles from './ThinkingImage.module.scss';

interface ThinkingImageProps extends Omit<React.HTMLProps<HTMLImageElement>, 'src' | 'alt'> {
  className?: string;
}

const tuningOffset = 1000;

const ThinkingImage = ({className, ...props}: ThinkingImageProps) => {
  const {animationDuration, animations} = useAnimationsContext();

  useEffect(() => {
    if (animations.thinking.isOpen) {
      setTimeout(animations.thinking.hide, animationDuration - tuningOffset);
    }
  }, [animations.thinking.isOpen]);

  return animations.thinking.isOpen && (
    <img src={animations.thinking.image} alt="thinking" className={classNames(styles.image, className)} {...props} />
  );
};

export default ThinkingImage;